import api from './apiService'

export const login = (identifier, password) =>
  api.post('/staff/login', { identifier, password })

export const me = () =>
  api.get('/staff/me')

// Encerra a sessão no backend (staff_sessions) -- login de funcionário agora
// suporta múltiplas sessões, então o logout precisa avisar o servidor pra
// invalidar a sessão atual, não só limpar o estado local (ver auth.store.js).
//
// `token` é passado explicitamente (em vez de depender do interceptor de
// apiService, que lê o bearer token do localStorage) porque auth.store.js
// já apagou `localStorage['user']` no momento em que essa chamada é
// disparada (a limpeza de estado precisa vir antes do redirect, ver
// AppLayout.vue::handleLogout) -- sem o header explícito, o interceptor não
// acharia mais token nenhum pra anexar e a chamada iria sem Authorization.
export const logout = (token) =>
  api.post('/staff/logout', undefined, token ? { headers: { Authorization: `Bearer ${token}` } } : undefined)

export const changePassword = (currentPassword, newPassword) =>
  api.post('/staff/me/change-password', { currentPassword, newPassword })
